import styled from "styled-components";
export const CustomerFileWrapper = styled.div`
  a {
    color: #fff;
  }
  .left-section {
    .left-card {
      background-color: ${({ theme }) => theme.box};
      border-radius: 10px;
      box-shadow: ${({ theme }) => theme.shadow};
      min-width: 300px !important;
      padding: 12px;
      min-height: 150px;
      .buttons {
        direction: ltr;
        button {
          padding: 4px 7px !important;
          margin-top: 0px !important;
        }
      }
      .successful {
        margin: 4px;
        border: 1px solid #009ef7;
        border-radius: 10px;
        padding: 10px;
      }
      .unsuccessful {
        margin: 4px;
        border: 1px solid #f1416c;
        border-radius: 10px;
        padding: 10px;
      }
    }
  }
`;
